import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { isDevMode } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

// Import the AuthService type from the SDK
// import { AuthService } from '@auth0/auth0-angular';
// import Cache from '@aws-amplify/cache';

import { Router, NavigationEnd } from "@angular/router";
import { Subscription } from "rxjs";
import { AccessGroupService } from "./components/access-group.service";
import { Location, DOCUMENT } from "@angular/common";
import { CommonDataService } from "./components/common-data.service";
import { Injectable } from "@angular/core";
import { map, filter, catchError, mergeMap } from "rxjs/operators";
// import { VersionCheckService } from "./version-check.service";
import { environment } from "../environments/environment";
import { HttpClient } from "@angular/common/http";
// import { Auth } from "./auth/auth.service";
import { generateClient } from 'aws-amplify/data';
import { Schema } from './../../amplify/data/resource';

// store
import { select, Store } from "@ngrx/store";
import * as fsProfileActions from "./store/action/fs.action";
import {OidcSecurityService} from 'angular-auth-oidc-client';

const client = generateClient<Schema>();

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  public menu_items: any;
  public email: any;
  public referrer: any;
  public profile: any;

  timer: number = 60000; //2700000 for 45 min  // 1 min 60000
  userActivity;
  userActive;
  active: boolean = false;
  counter: number = 0;
  storeNgrx: any;

  // Check for Authentication
  isAuthenticated: boolean;

  shouldDisplayOverlay: boolean = true;

  routerSubscription: Subscription;

  constructor(
    // public versionCheckService: VersionCheckService,
    // private authService: Auth,
    public oidcSecurityService: OidcSecurityService,
    private router: Router,
    public service: CommonDataService,
    public location: Location,
    public http: HttpClient,
    @Inject(DOCUMENT) private document: Document,
    public store: Store<any>,
  ) {
    // console.log("appMode:-",isDevMode());
    // Update Token for OIDC
    // this.authService.getIdTokenClaims().subscribe(message => {
    //     if(message.__raw){
    //     Cache.setItem('federatedInfo', { token: message.__raw });
    //     }else{
    //     console.log('TOKEN FAILURE!');
    //     }

    // });

    // this.startCounter();

    // hash-based routing
    // auth.handleRedirectCallback();
    // authService.handleAuthentication();

    // Attempt single sign-on authentication
    // if not authenticated
    // if (auth.isAuthenticated()) {
    //   this.shouldDisplayOverlay = false;
    // } else {
    //   auth.renewToken();
    // }
    // authService.scheduleRenewal();
    this.isAuthenticated = false;
  }

  ngOnInit() {
    var that = this;
    this.storeNgrx = this.store.select<any>((state) => state.profile.accessGroupData)
    this.oidcSecurityService.checkAuth().subscribe((loginResponse) => {
        const { isAuthenticated, userData, accessToken, idToken, configId } =
          loginResponse;
        // this.oidcSecurityService.getUserData(loginResponse.configId).subscribe(userData => {
        //   console.log("userData",userData);
        // })
        console.warn("RESPONSE ", loginResponse);
        console.log("RESPONSE ", loginResponse.errorMessage);
        if(!loginResponse.isAuthenticated) {
          console.log('impersonation', window.location.href.includes('/impersonation')) 
          if(!window.location.href.includes('/impersonation') && localStorage.getItem('impersonation') !== 'true' && !window.location.href.includes('/reset-password') && !window.location.href.includes('/congratulations')){
            if(!window.location.href.includes('/store') && !window.location.href.includes('/challenge-navigator-print-coach') && !window.location.href.includes('/slideshow') && !window.location.href.includes('/thinking-coach')){
              this.router.navigate(['/login']);
            }
          }
          if(localStorage.getItem('impersonation') === 'true'){
            this.storeActions();
          }
        } else {
          // this.versionCheckService.initVersionCheck(environment.versionCheckURL);
          this.routerSubscription = this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe((event) => {
              document.body.scrollTop = 0;
            });

            this.storeActions();
      
            this.oidcSecurityService.isAuthenticated$.subscribe(
              ({ isAuthenticated }) => {
                this.isAuthenticated = isAuthenticated;
        
                console.warn('authenticated: ', isAuthenticated);
              }
            );
      
          // this.fetchTodos();
          this.createAmplifyData();
        }
      });
  }

  public storeActions() {
    // profile action
    this.store.dispatch(fsProfileActions.getProfile());
    // access group action
    this.store.dispatch(fsProfileActions.getAccessGroup());
  }
  
  async fetchTodos() {
    console.log("client",client.models.LearnerMap)
    const data = await client?.models?.LearnerMap?.list({});
    console.log("==================>>>",data);
    console.log("==================>>>",data?.data[0]?.mapType?.values);
  }


  async createAmplifyData() {
    // console.log("createAmplifyData");
    // let num = Math.floor((Math.random() * 100) + 1)
    
    // const {data: LearnerMap, errors} = await client.models.LearnerMap.create({
    //   title: ["Hi thread1" + num],
    // });
    this.fetchTodos()
    // console.log("data",LearnerMap);
    // console.log("errors",errors);
  }

  ngOnDestroy() {
    this.routerSubscription.unsubscribe();
  }

  onActivate(e, scrollContainer) {
    scrollContainer.scrollTop = 0;
  }

  // SignOut
  public signOut(): void {
    // this.authService.logout();
  }
}
